import { type Icon } from "@phosphor-icons/react";
import clsx from "clsx";

import { Fork } from "~/components/Fork";
import { useLocale } from "~/hooks/locale";

export const ForkPrimary: React.FC<
  {
    title: string;
    description: string;
    icon: Icon;
    isNew?: boolean;
  } & React.ComponentProps<"button">
> = ({ icon: Icon, title, description, className, isNew, ...props }) => {
  const { t } = useLocale();
  return (
    <Fork
      className={clsx("group/fork p-6", isNew && "relative", className)}
      {...props}
    >
      <div className="space-y-3">
        <Icon weight="duotone" className="mx-auto size-12" />
        <div className="space-y-1.5 text-base-content group-disabled/fork:text-current">
          <div className="text-xl leading-tight title">{title}</div>
          <div>{description}</div>
        </div>
      </div>
      {isNew && (
        <div className="badge badge-accent absolute right-2 top-2">
          {t("new")}
        </div>
      )}
    </Fork>
  );
};
